import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { OpenTradeBillingInfoCheckBoxState } from "@tSurya/Store/Data/SurOpenTradeBillingInfoCheckboxState";
import { Draft } from "immer";

const initialState: OpenTradeBillingInfoCheckBoxState = {
    checkBox: false,
};

const reducer = {
    "Custom/OpenTradeAccount/BillingInfoCheckerBox": (
        draft: Draft<OpenTradeBillingInfoCheckBoxState>,
        action: { result: boolean },
    ) => {
        draft.checkBox = action.result;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
